<template>
  <div>
    <div class="row">

      <div class="col-6 mb-3">
        <h1>{{$t('menu.7')}}</h1>
      </div>
      <div class="col-6 mb-3 ">
        <el-button-group class="pull-right">
          <el-tooltip :content="$t('yeni')" placement="bottom">
            <el-button type="success" icon="el-icon-plus" @click="yeni"></el-button>
          </el-tooltip>
        </el-button-group>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <el-col :span="24">
          <el-table
            :data="veri()"
            style="width: 100%">
            <el-table-column
              :label="$t('kategori.adi')"
              prop="adi">
            </el-table-column>
            <el-table-column
              :label="$t('kategori.tur')"
              :prop="$t('kategori.turtip')">
            </el-table-column>
            <el-table-column
              align="right">
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  :placeholder="$t('ara')"/>
              </template>
              <template slot-scope="scope">
                <el-tooltip :content="$t('duzenle')" placement="right">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"><i class="i-Brush"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip :content="$t('sil')" placement="right">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, Data, scope.row)"><i class="i-Folder-Trash"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

        </el-col>
      </div>
    </div>

    <el-dialog :title="$t('kategori.isim')" :visible.sync="modal">

      <el-form :model="KategoriForm" status-icon ref="KategoriForm">
        <el-form-item
          prop="adi"
          :label="$t('kategori.adi')"
          autocomplete="off"
          :rules="[{ required: true, message: $t('kategori.bos') }]">
          <el-input v-model="KategoriForm.adi"></el-input>
        </el-form-item>

        <el-form-item
          prop="turu"
          :label="$t('kategori.tur')"
          autocomplete="off">

          <el-select v-model="KategoriForm.turu" :placeholder="$t('kategori.tur')">
            <el-option :label="$t('kategori.tur1')" value="1" selected></el-option>
            <el-option :label="$t('kategori.tur2')" value="2"></el-option>
            <el-option :label="$t('kategori.tur3')" value="3"></el-option>
            <el-option :label="$t('kategori.tur4')" value="4"></el-option>
          </el-select>

        </el-form-item>


        <el-form-item
          prop="id"
          autocomplete="off"
          type="hidden">
          <el-input type="hidden" :value="this.KategoriForm.id"></el-input>
        </el-form-item>


      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="modal = false">{{$t('iptal')}}</el-button>
        <el-button type="primary" @click="onSubmit('KategoriForm')">{{$t('kaydet')}}</el-button>

      </span>
    </el-dialog>

  </div>
</template>

<script>


    export default {
        data() {
            return {
                Data: [],
                modal: false,
                search: '',
                KategoriForm: {
                    id: '',
                    adi: '',
                    turu: '',
                },
                yenimodal: false,
                formLabelWidth: '180px',
            }
        },
        methods: {
            veri(){
                if (this.Data!=null){
                    var veri = this.Data.filter(data => !this.search || data.adi.toLowerCase().includes(this.search.toLowerCase()))
                }else if(this.Data==''){
                    var veri = this.Data;
                }
                return veri
            },
            handleEdit(index, row) {
                console.log(row)
                this.KategoriForm = row
                this.modal = true
            },
            handleDelete(index, row, rows) {
                row.splice(index, 1);
                console.log(rows)

                this.$store.dispatch("dataver", {
                    method: 'delete',
                    url: '/kategori/' + rows.id,
                    data: ''
                }).then(response => {
                    if (response.Status == 'OK') {

                    } else {

                    }
                });


            },
            KategoriListele() {
                this.$store.dispatch("dataver", {method: "get", url: "/kategori"})
                    .then(response => {
                        //console.log(response)
                        if (response.Status == 'OK') {
                            this.Data = response.Data;
                        } else {

                        }
                    });
            },
            onSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.yenimodal == false) {

                            this.$store.dispatch("dataver", {
                                method: 'put',
                                url: '/kategori/' + this.KategoriForm.id,
                                data: this.KategoriForsm
                            }).then(response => {
                                console.log(response)
                                if (response.Status == 'OK') {
                                    this.KategoriListele()
                                    this.modal = false
                                } else {

                                }
                            })

                        }
                        if (this.yenimodal == true) {

                            this.$store.dispatch("dataver", {
                                method: 'post',
                                url: '/kategori/',
                                data: this.KategoriForm
                            }).then(response => {
                                console.log(response)
                                if (response.Status == 'OK') {
                                    this.KategoriListele()
                                    this.modal = false
                                } else {

                                }
                            })

                        }

                    }
                });
            },
            yeni() {
                this.KategoriForm = {}
                this.yenimodal = true
                this.modal = true
            },
        },
        created() {
            this.KategoriListele()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/kategori/index.vue